export default __webpack_public_path__ + "642ec4b86300d4c579ddae96dc6d3cf7.svg";